export const PROPERTY_TYPES = [
  { value: "apartment", label: "Apartment / Flat" },
  { value: "villa", label: "Villa" },
  { value: "independent-house", label: "Independent House" },
  { value: "plot", label: "Residential Plot" },
  { value: "farmhouse", label: "Farmhouse" },
  { value: "agricultural-land", label: "Agricultural Land" },
  { value: "office", label: "Office Space" },
  { value: "shop", label: "Shop / Showroom" },
  { value: "commercial", label: "Commercial Space" },
  { value: "pg", label: "PG / Hostel" },
];

export const typeLabel = (v) => PROPERTY_TYPES.find((t) => t.value === v)?.label || v;

export const LISTING_TYPES = [
  { value: "sale", label: "Buy" },
  { value: "rent", label: "Rent" },
];

export const FURNISHING = [
  { value: "unfurnished", label: "Unfurnished" },
  { value: "semi-furnished", label: "Semi-Furnished" },
  { value: "furnished", label: "Furnished" },
];

export const AREA_UNITS = [
  { value: "sqft", label: "sq.ft" },
  { value: "sqyd", label: "sq.yd" },
  { value: "acre", label: "acre" },
];

export const STATUSES = [
  { value: "available", label: "Available" },
  { value: "sold", label: "Sold" },
  { value: "rented", label: "Rented" },
];

export const AMENITIES = [
  "Power Backup", "Lift", "Car Parking", "24x7 Security", "Park", "Gym",
  "Swimming Pool", "Club House", "Gated Community", "Water Connection",
  "Boundary Wall", "Wide Roads", "Electricity", "Vaastu Compliant",
];

export const SORT_OPTIONS = [
  { value: "newest", label: "Newest First" },
  { value: "price_low", label: "Price: Low to High" },
  { value: "price_high", label: "Price: High to Low" },
  { value: "area_high", label: "Area: Largest First" },
];

export const formatINR = (n) => {
  n = Number(n) || 0;
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2).replace(/\.00$/, "")} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2).replace(/\.00$/, "")} Lac`;
  return `₹${n.toLocaleString("en-IN")}`;
};

export const priceLabel = (p) => {
  const base = formatINR(p.price);
  return p.listing_type === "rent" ? `${base}/mo` : base;
};

export const areaLabel = (p) => `${p.area_value} ${p.area_unit}`;

export const slugify = (s) =>
  (s || "").toLowerCase().replace(/[^a-z0-9\s-]/g, "").trim().replace(/[\s-]+/g, "-");

export const localitySlug = (name, city = "Jaipur") => slugify(`${name}-${city}`);
